import { useEffect, ReactNode } from 'react';

// Import styles
import { AuthenticationContainer, AuthenticationContent } from './styles';

// Import helpers
import { recordPageView } from 'helpers/tracking';
import { VECTRA_LOGIN_BACKGROUND } from 'helpers/variables';

// Import components
import { Loader } from 'components/elements';
import AuthenticationProvider, { AuthenticationContext } from 'components/context/authentication/AuthenticationProvider';

// Import utilities
import { useProtectedPage } from 'components/utilities';

type Props = {
	children: ReactNode;
};

const AuthenticationTemplate = ({ children }: Props) => {
	const cover = useProtectedPage((state) => state.cover);
	const background = cover ? `${cover}=w1920-h1080-c` : VECTRA_LOGIN_BACKGROUND;

	useEffect(() => {
		recordPageView();
	}, []);

	return (
		<AuthenticationProvider>
			<AuthenticationContext.Consumer>
				{({ isLoading }) => (
					<AuthenticationContainer background={background} filter={background !== VECTRA_LOGIN_BACKGROUND}>
						{isLoading && <Loader />}
						<AuthenticationContent>{children}</AuthenticationContent>
					</AuthenticationContainer>
				)}
			</AuthenticationContext.Consumer>
		</AuthenticationProvider>
	);
};

export default AuthenticationTemplate;
